import { CamposGenericos } from "./camposGenericos";
import { CotizacionCabecera } from "./cotizacionCabecera";
import { CotizacionItemDescuento } from "./cotizacionItemDescuento";

export class CotizacionItem extends CamposGenericos {

    // calleNroDireccionEntrega: string;
    cantidad: number;
    // ciudadDireccionEntrega: string;
    // cPDireccionEntrega: string;
    descuentoCategoria: number;
    descuentoDiscrecional: number;
    distribuidor: boolean;
    entregaAFuturo: boolean;
    // fechaEntrega: Date;
    idCompania: string;
    idDivision: string;
    idPais: string;
    idPlanta: string;
    idProducto: string;
    idSalesOrg: string;
    idTipoOrden: string;
    idUbicacionAlmacenamiento: string;
    // nombreClienteDireccionEntrega: string;
    // nroClienteDireccionEntrega: string;
    nroLinea: number;
    nroPedido: number;
    planta: string;
    porcentajeDiscrecional: number;
    porcentajeRecargo: number;
    precioFinal: number;
    precioKGL: number;
    precioUnitarioFinal: number;
    precioUnitarioLista: number;
    producto: string;
    recargo: number;
    recargoLocal: number;
    tipoOrden: string;
    total: number;
    totalDescuento: number;
    totalLocal: number;
    totalPrecioKGL: number;
    itemDistribuidor: boolean;
    itemPlanta: boolean;
    fechaCantidadDisponible: Date;
    cantidadDisponible: number;
    fechaActualizacion: Date;
    unidadesPallet:number;
    itemsDescuentos: CotizacionItemDescuento[] = [];
    fechaPrimerCuotaDistribuidor: Date
    fechaSegundaCuotaDistribuidor: Date
    fechaTercerCuotaDistribuidor: Date
    public constructor(init?: Partial<CotizacionCabecera>) {
        super();
        Object.assign(this, init);
    }
}